<script setup>
import { computed, inject, ref } from 'vue'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)
const { isBrowser } = inject('Shared')
const { pages } = inject('Shared')
let DoughnutChart
if (isBrowser) {
  DoughnutChart = require('vue-chart-3').DoughnutChart
}
const props = defineProps(['data', 'animated', 'width', 'height'])
const computedData = computed(() => {
  const circumference = props.data * 3
  let dataValues
  if (props.data < 33.34) { dataValues = [props.data] }
  if (props.data > 33.33 && props.data < 66.67) { dataValues = [33.33, props.data - 33.33] }
  if (props.data > 66.66 && props.data <= 100) { dataValues = [33.33, 33.33, props.data - 66.66] }
  return { circumference, dataValues }
})

function hexToRGB (hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')'
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')'
  }
}

const bgData = computed(() => ({
  datasets: [
    {
      borderWidth: 0,
      hoverBorderWidth: 0,
      spacing: 10,
      offset: -10,
      circumference: 300,
      borderRadius: 100,
      data: [33.33, 33.33, 33.33],
      backgroundColor: [hexToRGB(pages.value.detailReport.potentialAnalysis.progressLineBackgroundLow, 0.5), hexToRGB(pages.value.detailReport.potentialAnalysis.progressLineBackgroundMedium, 0.5), hexToRGB(pages.value.detailReport.potentialAnalysis.progressLineBackgroundHigh, 0.5)]
    }
  ]
}))
const chartData = computed(() => ({
  datasets: [
    {
      hoverBackgroundColor: [pages.value.detailReport.potentialAnalysis.progressLineBackgroundLow, pages.value.detailReport.potentialAnalysis.progressLineBackgroundMedium, pages.value.detailReport.potentialAnalysis.progressLineBackgroundHigh],
      borderWidth: 0,
      spacing: 12,
      offset: -10,
      borderRadius: 100,
      data: computedData.value.dataValues,
      circumference: computedData.value.circumference,
      backgroundColor: [pages.value.detailReport.potentialAnalysis.progressLineBackgroundLow, pages.value.detailReport.potentialAnalysis.progressLineBackgroundMedium, pages.value.detailReport.potentialAnalysis.progressLineBackgroundHigh]
    },
    {
      weight: 0,
      borderWidth: 0,
      hoverBorderWidth: 0,
      borderRadius: 100,
      circumference: 300,
      data: [33.33, 33.33, 33.33],
      backgroundColor: ['transparent', 'transparent', 'transparent']
    }
  ]
}))

const options = ref({
  responsive: true,
  rotation: 210,
  cutout: '80%',
  animations: !props.animated ? props.animated : void 0,
  plugins: {
    tooltip: {
      enabled: false
    },
    legend: {
      display: false
    }
  }
})
</script>

<template lang="pug">
.gauge(v-if="isBrowser")
  slot
  .gauge--bg
    DoughnutChart(:chart-data="bgData" :options="options")
  .gauge--chart
    DoughnutChart(:chart-data="chartData" :options="options")
</template>

<style lang="sass" scoped>
.gauge
  width: v-bind(width)
  height: v-bind(height)
  position: relative
  .gauge--chart, .gauge--bg
    position: absolute
</style>
